import React from 'react';
import { FieldComponent } from '../../../types/FieldComponent';
import { BooleanFilter } from '../filters/BooleanFilter';

export const BooleanField: FieldComponent<boolean> = ({
  onChange,
  isActive,
  value = true,
}) => {
  const [checked, setChecked] = React.useState(false);

  const handleChange = () => {
    setChecked(!checked);
    onChange(!checked);
  };

  return <></>;
};

BooleanField.includes = (query = undefined, value = undefined) => {
  if (query === undefined || value === undefined || value === null) return true;
  const valueString = value.toString();
  //console.log(query,valueString);
  return query.some((queryPart: string) => {
    valueString.includes(queryPart);
  });
};

BooleanField.comparator = (one = false, other = false) => {
  if (one === other) return 0;
  if (one && !other) return -1;
  return 1;
};

BooleanField.FilterRenderer = BooleanFilter;
